<template>
  <component
    :is="isDesktopFormLayout ? 'ProductFormDesktopBridge' : 'ProductFormMobile'"
  />
</template>

<script>
// import aicomplete from '../../components/general/AIcomplete/index'
import General from "../../../../Mixins/general";
// import Dropbox from '../../components/general/dropbox/index'
import filePicker from "../../components/general/filePicker/index";
import customFields from "../../components/general/customFields/index.vue";
import Pricing from "./pricing";
import DigikalaIntegrator from "./partial/DigikalaIntegrator";
import SazitoIntegrator from "./partial/SazitoIntegrator.vue";
import Portal3Integrator from "./partial/Portal3Integrator.vue";
import MixinIntegrator from "./partial/MixinIntegrator.vue";
import SnapshopIntegrator from "./partial/SnapshopIntegrator.vue";
import Description from "../../components/general/description/Description";
import VariableProductTab from "./partial/VariableProductTab.vue";
import SerialManagementDialog from "../../components/general/serials/SerialManagementDialog";
import ProductFormDesktopBridge from "./layouts/desktop/ProductFormDesktopBridge.vue";
import ProductFormMobile from "./layouts/mobile/ProductFormMobile.vue";
import {
  TiptapVuetify,
  Heading,
  Bold,
  Italic,
  Strike,
  Underline,
  Code,
  Paragraph,
  BulletList,
  OrderedList,
  ListItem,
  Link,
  Blockquote,
  HardBreak,
  HorizontalRule,
  History,
  Image,
  Table,
  TableCell,
  TableHeader,
  TableRow,
} from "tiptap-vuetify";

const DEFAULT_CARD_HEIGHT = "calc(100vh - 98px)";
const DEFAULT_SHOW_SIMPLE = false;
const DEFAULT_TOOLBAR_TITLE = true;
const PRODUCT_DESKTOP_MIN_WIDTH = 800;

export default {
  name: "Product",
  provide() {
    return {
      productForm: this,
    };
  },
  components: {
    ProductFormDesktopBridge,
    ProductFormMobile,
    autocomplete: () => import("../../components/general/patial/autocomplete"),
    aicomplete: () => import("../../components/general/AIcomplete/index"),
    TiptapVuetify,
    customFields,
    filePicker,
    // Dropbox,
    Pricing,
    Tag: () => import("../../components/general/Tag/tag"),
    DigikalaIntegrator,
    SazitoIntegrator,
    Portal3Integrator,
    MixinIntegrator,
    SnapshopIntegrator,
    Description,
    VariableProductTab,
    SerialManagementDialog,
  },
  mixins: [General],
  props: {
    formType: {},
    idProp: {},
    invoiceTrigger: {},
    cardHeight: {
      type: String,
      default: DEFAULT_CARD_HEIGHT,
    },
    showSimple: {
      type: Boolean,
      default: DEFAULT_SHOW_SIMPLE,
    },
    toolbarTitle: {
      type: Boolean,
      default: DEFAULT_TOOLBAR_TITLE,
    },
  },
  data() {
    return {
      simple: this.showSimple,
      woocommerceIdItems: [],
      basalamIdItems: [],
      isVariableProduct: false,
      wasVariableProduct: false,
      has_serial: "deactive",
      serialDialog: false,
      serialItem: null,
      productTab: 0,
      variableVariants: [],
      render: true,
      isKalaBarg: false,
      countWoocommercepanel: 1,
      taxPercent: 10,
      priceWithTax: 0,
      discountPercent: 0,
      initial_stocks: [],
      displayPriority: null,
      constructionWagesPercent: null,
      commissionPercent: null,
      profitPercent: null,
      discount: null,
      length: null,
      width: null,
      height: null,
      webziVariantId: null,
      webziId: null,
      sazitoVariantId: null,
      sazitoId: null,
      markitoId: null,
      defaultUnit: null,
      customFields: null,
      taxid: null,
      imagePicker: null,
      imagePickerVal: null,
      removeAvatar: false,
      productImages: null,
      productImagesVal: null,
      kind: null,
      body: null,
      digikalaPanel: [],
      sazitoPanel: [],
      portalPanel: [],
      mixinPanel: [],
      snapshopPanel: [],
      /* digikalaFixCount: null, */
      barcodes: [],
      allocations: [{ percent: null, from_date: null, to_date: null }],
      investors: [],
      units: [],
      sellCosts: [],
      extensions: [
        History,
        Table,
        TableCell,
        TableHeader,
        TableRow,
        Blockquote,
        Link,
        Underline,
        Strike,
        Italic,
        ListItem, // if you need to use a list (BulletList, OrderedList)
        BulletList,
        OrderedList,
        Image,
        [
          Heading,
          {
            // Options that fall into the tiptap's extension
            options: {
              levels: [1, 2, 3],
            },
          },
        ],
        Bold,
        Code,
        HorizontalRule,
        Paragraph,
        HardBreak, // line break on Shift + Ctrl + Enter
      ],
      isLoading: false,
      alert: false,
      inventoryMethod: "average",
      priceMethod: "max",
      priceMethodItems: [],
      portalId: null,
      portalVariantId: null,
      /* digikalaVariantId: null, */
      woocommerceId: null,
      initialCheck: true,
      pricing: null,
      woocommerceVariantId: null,
      woocommerceFixCount: null,
      image: null,
      costs: null,
      tag: null,
      weight: null,
      orderPoint: null,
      valid: null,
      message: null,
      alertType: null,
      name: null,
      group: null,
      cat1: null,
      cat2: null,
      unit: null,
      fee: null,
      count: 0,
      id: null,
      currency: null,
      status: "active",
      entrepot: null,
      barcode: null,
      code: 1,
      type: "product",
      timer: null,
      price: null,
      loading: false,
      custom_code: null,
      content: null,
      /** بعد از ثبت موفق زیاد می‌شود تا فرم و کامپوننت‌های فرزند از نو ساخته شوند */
      formResetKey: 0,
      panel: undefined,
    };
  },
  watch: {
    isVariableProduct(val) {
      if (this.wasVariableProduct && !val) {
        this.isVariableProduct = true;
      }
    },
    formType(val) {
      const normalized = (val || "").toLowerCase();
      if (["product", "service"].includes(normalized)) {
        this.type = normalized;
      }
    },
    idProp() {
      this.render = true;
      if (this.idProp != null) {
        this.id = this.idProp;
        this.show();
        this.render = false;
      } else {
        this.render = false;
      }
    },
    image() {},
    group(Val, oldVal) {
      if (this.$refs.refCat2 && this.$refs.refCat1) {
        if (Val) {
          this.$refs.refCat1.clear();
          this.$refs.refCat2.clear();
          this.$refs.refCat1.initList = false;
          this.$refs.refCat1.getItems();
        } else {
          this.$refs.refCat1.clear();
          this.$refs.refCat2.clear();
        }
      }
    },
    cat1(Val, oldVal) {
      if (this.$refs.refCat2) {
        if (Val) {
          this.$refs.refCat2.clear();
          this.$refs.refCat2.initList = false;
          this.$refs.refCat2.getItems();
        } else {
          this.$refs.refCat2.clear();
        }
      }
    },
  },
  computed: {
    normalizedFormType() {
      return (this.formType || "").toLowerCase();
    },
    showTypeSelector() {
      return !["product", "service"].includes(this.normalizedFormType);
    },
    isMobile() {
      return this.$vuetify.breakpoint.name === "sm";
    },
    /**
     * Desktop Bridge vs mobile layout.
     * Embedded forms (formType) stay desktop; otherwise width like invoice.
     */
    isDesktopFormLayout() {
      if (this.formType) return true;
      return this.$vuetify.breakpoint.width >= PRODUCT_DESKTOP_MIN_WIDTH;
    },
    cardHeightStyle() {
      const h = (this.cardHeight || "").trim();
      return { height: h || DEFAULT_CARD_HEIGHT };
    },
    serialDialogProduct() {
      return {
        id: this.id || null,
        name: this.name || "",
        has_serial: this.has_serial,
      };
    },
  },
  beforeMount() {
    this.inventoryMethodItems = [
      {
        value: "average",
        text: this.$t("weightedAverage"),
      },
      {
        value: "fifo",
        text: this.$t("fifo"),
      },
      {
        value: "lifo",
        text: this.$t("lifo"),
      },
    ];

    this.priceMethodItems = [
      {
        value: "first",
        text: this.$t("firstCost"),
      },
      {
        value: "min",
        text: this.$t("minCost"),
      },
      {
        value: "average",
        text: this.$t("averageCost"),
      },
      {
        value: "max",
        text: this.$t("maxCost"),
      },
      {
        value: "last",
        text: this.$t("lastCost"),
      },
    ];
    if (["product", "service"].includes(this.normalizedFormType)) {
      this.type = this.normalizedFormType;
    } else if (this.$route.name === "Service") {
      this.type = "service";
    } else {
      this.type = "product";
    }
    // in invoice/dialog(edit path) use of id_prop
    if (this.idProp != null && typeof this.idProp !== "undefined") {
      this.id = this.idProp;
      this.show();
      this.render = false;
    } else if (this.formType) {
      // in invoice create/ignore $route.params.id just open dialog
      this.render = true;
      this.checkCode();
    } else if (this.$route.params.id != null) {
      // for edit product(product path)use of route
      this.id = this.$route.params.id;
      this.show();
      this.render = false;
    } else {
      this.render = true;
      this.checkCode();
      // this.addInitialStock()
    }
  },
  mounted() {
    this.$emit("trigger", this.simple);
    if (this.woocommerceIdItems.length === 0) {
      this.addWoocommerceIdItems();
    }
    if (this.basalamIdItems.length === 0) {
      this.addBaSalamIdItems();
    }
  },
  methods: {
    entrepotRuls(initial) {
      return Number(initial.stock) > 0 ? [(v) => !!v || this.$t("is-required")] : [];
    },
    shortkeyCreateSubmit() {
      this.create(true);
    },
    shortkeyCreateSubmitNew() {
      this.create(false);
    },
    normalizeVariantPanels(v) {
      const isEmptySentinel = (arr) =>
        Array.isArray(arr) && arr.length === 1 && arr[0] === "empty";
      const clean = (arr) => {
        if (!Array.isArray(arr) || isEmptySentinel(arr)) return [];
        return [...arr];
      };
      let digikalaPanel = clean(v.digikalaPanel);
      let sazitoPanel = clean(v.sazitoPanel);
      let portalPanel = clean(v.portalPanel);
      let mixinPanel = clean(v.mixinPanel);
      let snapshopPanel = clean(v.snapshopPanel);
      const hasData = (arr) => arr.length > 0;

      if (
        digikalaPanel.length === 0 &&
        (hasData(sazitoPanel) ||
          hasData(portalPanel) ||
          hasData(mixinPanel) ||
          hasData(snapshopPanel))
      ) {
        digikalaPanel = ["empty"];
      }
      if (
        sazitoPanel.length === 0 &&
        portalPanel.length === 0 &&
        (hasData(digikalaPanel) || hasData(mixinPanel) || hasData(snapshopPanel))
      ) {
        sazitoPanel = ["empty"];
        portalPanel = ["empty"];
      }
      if (
        mixinPanel.length === 0 &&
        (hasData(digikalaPanel) ||
          hasData(sazitoPanel) ||
          hasData(portalPanel) ||
          hasData(snapshopPanel))
      ) {
        mixinPanel = ["empty"];
      }
      if (
        snapshopPanel.length === 0 &&
        (hasData(digikalaPanel) ||
          hasData(sazitoPanel) ||
          hasData(portalPanel) ||
          hasData(mixinPanel))
      ) {
        snapshopPanel = ["empty"];
      }
      return { digikalaPanel, sazitoPanel, portalPanel, mixinPanel, snapshopPanel };
    },
    normalizeArticleSerials(source) {
      return (source || [])
        .map((serial, index) => {
          const raw =
            typeof serial === "string"
              ? serial
              : serial &&
                (serial.value ||
                  serial.serial ||
                  serial.serial_number ||
                  serial.code ||
                  "");
          const value = String(raw || "").trim();
          if (!value) return null;
          return {
            id: (serial && (serial.id || serial.serial_id)) || null,
            uid: (serial && (serial.uid || serial.id)) || `${value}-${index}`,
            value,
            product_id:
              (serial && (serial.product_id || serial.productId)) ||
              this.id ||
              null,
            created_at: (serial && (serial.created_at || serial.createdAt)) || "",
            selected: serial && serial.selected !== undefined ? !!serial.selected : true,
          };
        })
        .filter(Boolean);
    },
    hydrateInitialStockRow(stock) {
      return {
        ...stock,
        serials: this.normalizeArticleSerials(
          Array.isArray(stock && stock.serials) ? stock.serials : []
        ),
        _serialEntrepotId:
          stock && stock.entrepot && stock.entrepot.id ? stock.entrepot.id : null,
      };
    },
    sanitizeInitialStocks(stocks) {
      return (stocks || []).map((stock) => {
        const next = { ...stock };
        delete next._serialEntrepotId;
        next.serials = this.normalizeArticleSerials(
          Array.isArray(next.serials) ? next.serials : []
        );
        return next;
      });
    },
    buildProductPayload() {
      const payload = { ...this.$data };
      delete payload.serialDialog;
      delete payload.serialItem;
      if (this.isVariableProduct) {
        payload.initial_stocks = [];
        payload.variants = (this.variableVariants || []).map((v) => {
          const panels = this.normalizeVariantPanels(v);
          return {
            id: v.id,
            name: v.name,
            baseName: v.baseName,
            attributes: v.attributes || [],
            sku: v.sku,
            code: v.code,
            custom_code: v.custom_code,
            displayPriority: v.displayPriority,
            status: v.status,
            taxid: v.taxid,
            taxPercent: v.taxPercent,
            price: v.price,
            priceWithTax: v.priceWithTax,
            discount: v.discount,
            discountPercent: v.discountPercent,
            isKalaBarg: v.isKalaBarg,
            barcode: v.barcode,
            barcodes: v.barcodes || [],
            tag: v.tag,
            pricing: v.pricing,
            length: v.length,
            width: v.width,
            height: v.height,
            weight: v.weight,
            orderPoint: v.orderPoint,
            investors: v.investors || [],
            initial_stocks: this.sanitizeInitialStocks(v.initial_stocks),
            woocommerceIdItems: v.woocommerceIdItems || [],
            basalamIdItems: v.basalamIdItems || [],
            digikalaPanel: panels.digikalaPanel,
            sazitoPanel: panels.sazitoPanel,
            portalPanel: panels.portalPanel,
            mixinPanel: panels.mixinPanel,
            snapshopPanel: panels.snapshopPanel,
            markitoId: v.markitoId ?? null,
            portalId: v.portalId ?? null,
            portalVariantId: v.portalVariantId ?? null,
            webziId: v.webziId ?? null,
            webziVariantId: v.webziVariantId ?? null,
          };
        });
        // Parent integrator UI is disabled for variable products; avoid sending
        // empty parent panels that could clear unrelated parent-level data.
        payload.digikalaPanel = [];
        payload.sazitoPanel = [];
        payload.portalPanel = [];
        payload.mixinPanel = [];
        payload.snapshopPanel = [];
        payload.woocommerceIdItems = [];
        payload.basalamIdItems = [];
        payload.markitoId = null;
        payload.portalId = null;
        payload.portalVariantId = null;
        payload.webziId = null;
        payload.webziVariantId = null;
      } else {
        payload.variants = [];
        payload.initial_stocks = this.sanitizeInitialStocks(this.initial_stocks);
      }
      payload.variantFields = (this.variableVariants || []).flatMap((v) =>
        (v.attributes || [])
          .filter((a) => a && a.key)
          .map((a) => ({ key: a.key, value: a.value }))
      );
      return payload;
    },
    addBaSalamIdItems() {
      var item = {
        basalamPanelName: null,
        basalamId: null,
        basalamVariantId: null,
      };
      this.basalamIdItems.push(item);
    },
    removeBaSalamId(item) {
      var i = this.basalamIdItems.indexOf(item);
      this.basalamIdItems.splice(i, 1);
    },
    addWoocommerceIdItems() {
      if (
        this.$store.state.allConfig &&
        this.$store.state.allConfig.countWoocommercePanel
      ) {
        this.countWoocommercepanel = this.$store.state.allConfig.countWoocommercePanel;
      }
      if (this.woocommerceIdItems.length < this.countWoocommercepanel) {
        var item = {
          woocommercePanelName: null,
          woocommerceId: null,
          woocommerceVariantId: null,
          woocommerceFixCount: null,
        };
        this.woocommerceIdItems.push(item);
      }
    },
    removeWoocommerceId(item) {
      var i = this.woocommerceIdItems.indexOf(item);
      this.woocommerceIdItems.splice(i, 1);
    },
    calcPrice() {
      if (this.taxPercent && this.taxPercent > 0) {
        clearTimeout(this.timer);
        var app = this;
        this.timer = setTimeout(function () {
          var tax = 0;
          var netPrice = +app.priceWithTax / (1 + +app.taxPercent / 100);
          tax = app.roundMath(
            +app.priceWithTax - +netPrice,
            app.$store.state.currency.decimal
          );
          var price = +app.priceWithTax - +tax;
          app.price = price;
        }, 1000);
      }
    },
    calcPriceWithTax() {
      if (this.taxPercent && this.taxPercent > 0) {
        var TaxAmount = +this.price * (1 + +this.taxPercent / 100);
        this.priceWithTax = +this.roundMath(
          TaxAmount,
          this.$store.state.currency.decimal
        );
      }
    },
    validateStock(initial) {
      setTimeout(function () {
        if (initial.stock < 0) {
          initial.stock = 0;
        }
      }, 50);
    },
    checkEntrepot(item, j) {
      var app = this;
      const prevEntrepotId = item._serialEntrepotId || null;
      const nextEntrepotId = item.entrepot && item.entrepot.id ? item.entrepot.id : null;
      if (prevEntrepotId && prevEntrepotId !== nextEntrepotId) {
        this.$set(item, "serials", []);
      }
      item._serialEntrepotId = nextEntrepotId;
      if (!nextEntrepotId) {
        this.$set(item, "serials", []);
      }
      if (item.entrepot && this.initial_stocks.length > 1) {
        for (let i = 0; i < this.initial_stocks.length; i++) {
          const value = this.initial_stocks[i];
          if (
            j !== i &&
            value.entrepot &&
            value.entrepot.id &&
            value.entrepot.id === item.entrepot.id
          ) {
            setTimeout(function () {
              app.snakbarText = app.$t("selectedWarehouseIsdDuplicate");
              app.snakbarColor = "pink";
              app.snakbar = true;
              app.initial_stocks[j].entrepot = null;
              app.$set(app.initial_stocks[j], "serials", []);
              app.initial_stocks[j]._serialEntrepotId = null;
            }, 200);
            break;
          }
        }
      }
    },
    openInitialStockSerialDialog(initial) {
      if (!initial || !initial.entrepot || !initial.entrepot.id) return;
      this.$set(
        initial,
        "serials",
        this.normalizeArticleSerials(
          Array.isArray(initial.serials) ? initial.serials : []
        )
      );
      this.serialItem = initial;
      this.serialDialog = true;
    },
    setInitialStockSerials(serials) {
      if (!this.serialItem) return;
      this.$set(this.serialItem, "serials", this.normalizeArticleSerials(serials || []));
    },
    addInitialStock() {
      var row = {
        stock: 0,
        price: 0,
        entrepot: null,
        serials: [],
        _serialEntrepotId: null,
      };
      this.initial_stocks.push(row);
    },
    removeInitialStock(i) {
      this.initial_stocks.splice(i, 1);
    },
    changeInvestor(item) {
      if (!item.id) {
        if (item.investor) {
          item.investorSellPercent = item.investor.investorSellPercent;
          item.investorReturnSellPercent = item.investor.investorReturnSellPercent;
        } else {
          item.investorSellPercent = null;
          item.investorReturnSellPercent = null;
        }
      }
    },
    clearDefaultUnits(item, i) {
      this.units.map(function (value, index) {
        if (index !== i) {
          value.default = null;
        }
      });
    },
    removeUnit(item) {
      var i = this.units.indexOf(item);
      this.units.splice(i, 1);
    },
    removeBarcode(item) {
      var i = this.barcodes.indexOf(item);
      this.barcodes.splice(i, 1);
    },
    addUnitRow() {
      this.units.push({
        unit: null,
        value: null,
        default: null,
      });
    },
    addBarcode() {
      this.barcodes.push({
        value: null,
      });
    },
    //add allocations
    addAllocationRow() {
      this.allocations.push({
        percent: null,
        from_date: null,
        to_date: null,
      });
    },
    removeAllocation(item) {
      var i = this.allocations.indexOf(item);
      this.allocations.splice(i, 1);
    },
    //
    addInvestorRow() {
      this.investors.push({
        investor: null,
        investorSellPercent: null,
        investorReturnSellPercent: null,
      });
    },
    addSellCostRow() {
      this.sellCosts.push({
        detail: null,
        amount: null,
      });
    },
    removeInvestor(item) {
      var i = this.investors.indexOf(item);
      this.investors.splice(i, 1);
    },
    removeSellCost(item) {
      var i = this.sellCosts.indexOf(item);
      this.sellCosts.splice(i, 1);
    },
    onCancel() {
      window.JsBarcode(".barcode").init();
    },
    onPicked(files) {
      files.forEach((file) => {});
    },
    checkCode() {
      var app = this;
      app.loading = true;
      app.$axios
        .get(this.$endpoint + "products", {
          params: {
            checkCode: app.code,
            product_id: app.id,
          },
        })
        .then((res) => {
          res = res.data;
          app.code = res.data;
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
    create(submitOnly = true, type = null) {
      if (
        this.$refs.form &&
        typeof this.$refs.form.validate === "function" &&
        !this.$refs.form.validate()
      ) {
        return false;
      }
      var Submit = submitOnly === true;
      var app = this;
      app.alert = false;
      app.isLoading = true;
      app.currency = app.defaultCurrency;
      if (
        !app.isVariableProduct &&
        app.digikalaPanel != undefined &&
        app.sazitoPanel != undefined &&
        app.portalPanel != undefined &&
        app.mixinPanel != undefined &&
        app.snapshopPanel != undefined
      ) {
        if (
          app.digikalaPanel.length == 0 &&
          (app.sazitoPanel.length > 0 ||
            app.portalPanel.length > 0 ||
            app.mixinPanel.length > 0 ||
            app.snapshopPanel.length > 0)
        ) {
          app.digikalaPanel = ["empty"];
        }
        if (
          app.sazitoPanel.length == 0 &&
          app.portalPanel.length == 0 &&
          (app.digikalaPanel.length > 0 ||
            app.mixinPanel.length > 0 ||
            app.snapshopPanel.length > 0)
        ) {
          app.sazitoPanel = ["empty"];
          app.portalPanel = ["empty"];
        }
        if (
          app.mixinPanel.length == 0 &&
          (app.digikalaPanel.length > 0 ||
            app.sazitoPanel.length > 0 ||
            app.portalPanel.length > 0 ||
            app.snapshopPanel.length > 0)
        ) {
          app.mixinPanel = ["empty"];
        }
        if (
          app.snapshopPanel.length == 0 &&
          (app.digikalaPanel.length > 0 ||
            app.sazitoPanel.length > 0 ||
            app.portalPanel.length > 0 ||
            app.mixinPanel.length > 0)
        ) {
          app.snapshopPanel = ["empty"];
        }
      }
      app.$axios
        .post(app.$endpoint + "products", app.buildProductPayload())
        .then((res) => {
          app.snakbarText = app.$t("registered");
          app.snakbarColor = "green";
          app.snakbar = true;
          res = res.data;
          if (app.imagePicker && app.$refs.refFilePicker) {
            app.$refs.refFilePicker.create(res.data.id);
          }
          if (app.productImages && app.$refs.refProductImages) {
            app.$refs.refProductImages.create(res.data.id);
          }
          if (app.id) {
            if (app.type === "product") {
              app.goTo("ProductList");
            } else {
              app.goTo("ServiceList");
            }
          } else {
            if (app.invoiceTrigger) {
              res = res.data;
              var product = {
                id: res.id,
                name: res.name,
                code: res.code,
                fin_id: res.fin_id,
                barcode: res.barcode,
                group_id: res.group_id,
                count: 0,
                unit_id: res.unit_id,
                price: res.price,
                custom_code: res.financial.custom_code,
                type: res.type,
                unit: {
                  id: app.unit.id,
                  name: app.unit.name,
                  fame: app.unit.name,
                },
                tax_percent: app.taxPercent,
                discount_percent: app.discountPercent,
              };
              app.$emit("addproduct", product);
            } else {
              app.$emit("input", res.data.data);
            }
            app.render = false;
            app.$nextTick(() => {
              app.render = true;
            });
          }
        })
        .catch((err) => {
          if (err.response && err.response.status === 409) {
            this.$store.commit("SET_PLAN_DIALOG", true);
          }
          this.serverErrorHandeler(err);
        })
        .finally(() => {
          this.isLoading = false;
          if (Submit === true) {
            app.$emit("close-create-modal");
            app.$emit("close", app.$route);
          }
          app.clearForm();
          // app.snakbar = false
        });
    },
    show() {
      var app = this;
      // app.clearForm()
      app.loading = true;
      app.clearing = true;
      app.showing = true;
      app.$axios
        .get(app.$endpoint + "products/" + app.id + "/edit", {
          params: {
            id: app.id,
          },
        })
        .then((res) => {
          app.$nextTick(() => {
            res = res.data;
            app.isKalaBarg = res.is_kala_barg ?? res.isKalaBarg ?? false;
            app.typeForm = res.type;
            app.type = res.type;
            app.id = res.id;
            app.woocommerceIdItems = res.woocommerceIdItems ? res.woocommerceIdItems : [];
            app.basalamIdItems = res.basalamIntegrator ? res.basalamIntegrator : [];
            app.branch = res.branch;
            app.name = res.name;
            app.status = res.status;
            app.taxid = res.taxid;
            app.content = res.content;
            app.barcodes = res.barcodes;
            app.code = res.code;
            app.initial_stocks = (res.initial_stocks || []).map((stock) =>
              app.hydrateInitialStockRow(stock)
            );
            app.taxPercent = res.tax_percent;
            app.profitPercent = res.profit_percent;
            app.commissionPercent = res.commission_percent;
            app.constructionWagesPercent = res.construction_wages_percent;
            app.discountPercent = res.discount_percent;
            app.customFields = res.custom_fields;
            // app.variableVariants = res.variable_variants || res.variants || [];
            app.variableVariants = (res.variable_variants || res.variants || []).map(
              (row) => {
                const v = row.variant || row;
                const integrator = v.integrator || row.integrator || {};
                const cleanPanel = (panels) => {
                  if (!Array.isArray(panels)) return [];
                  if (panels.length === 1 && panels[0] === "empty") return [];
                  return panels;
                };
                return {
                  id: v.id,
                  name: v.name,
                  baseName: v.baseName || v.name,
                  sku: v.sku,
                  code: v.code,
                  custom_code: v.custom_code,
                  displayPriority: v.displayPriority ?? v.priority ?? null,
                  price: v.price,
                  priceWithTax: v.priceWithTax ?? v.price_with_tax ?? 0,
                  discount: v.discount,
                  status: v.status || "active",
                  taxid: v.taxid,
                  taxPercent: v.tax_percent ?? v.taxPercent ?? 10,
                  discountPercent: v.discount_percent ?? v.discountPercent ?? 0,
                  isKalaBarg: v.isKalaBarg ?? v.is_kala_barg ?? false,
                  barcode: v.barcode,
                  tag: v.tag || v.tags || null,
                  pricing: v.pricing || null,
                  length: v.length,
                  width: v.width,
                  height: v.height,
                  weight: v.weight,
                  orderPoint: v.order_point ?? v.orderPoint,
                  attributes: v.attributes || [],
                  barcodes: v.barcodes || [],
                  investors: v.investors || row.investors || [],
                  initial_stocks: (
                    v.initial_stocks ||
                    row.initial_stocks ||
                    []
                  ).map((stock) => app.hydrateInitialStockRow(stock)),
                  initialCheck:
                    v.initialCheck !== undefined
                      ? v.initialCheck
                      : row.initialCheck !== undefined
                      ? row.initialCheck
                      : undefined,
                  woocommerceIdItems:
                    v.woocommerceIdItems || row.woocommerceIdItems || [],
                  basalamIdItems:
                    v.basalamIdItems ||
                    v.basalamIntegrator ||
                    row.basalamIdItems ||
                    row.basalamIntegrator ||
                    [],
                  digikalaPanel: cleanPanel(v.digikalaPanel || row.digikalaPanel),
                  sazitoPanel: cleanPanel(v.sazitoPanel || row.sazitoPanel),
                  portalPanel: cleanPanel(v.portalPanel || row.portalPanel),
                  mixinPanel: cleanPanel(v.mixinPanel || row.mixinPanel),
                  snapshopPanel: cleanPanel(v.snapshopPanel || row.snapshopPanel),
                  markitoId: v.markitoId ?? integrator.markitoId ?? null,
                  portalId: v.portalId ?? integrator.portalId ?? null,
                  portalVariantId:
                    v.portalVariantId ?? integrator.portalVariantId ?? null,
                  webziId: v.webziId ?? integrator.webziId ?? null,
                  webziVariantId: v.webziVariantId ?? integrator.webziVariantId ?? null,
                };
              }
            );
            if (typeof res.is_variable_product !== "undefined") {
              app.isVariableProduct = !!res.is_variable_product;
            } else if (typeof res.isVariableProduct !== "undefined") {
              app.isVariableProduct = !!res.isVariableProduct;
            } else if (app.variableVariants.length) {
              app.isVariableProduct = true;
            }
            app.wasVariableProduct = app.isVariableProduct;

            app.has_serial = res.has_serial || "deactive";
            if (app.$route.query["variant-id"] && app.isVariableProduct) {
              app.$nextTick(() => {
                app.productTab = 1;
              });
            }
            app.imagePicker = res.avatar;
            app.imagePickerVal = res.avatar;
            app.productImages = res.product_images_val;
            app.productImagesVal = res.product_images_val;
            app.custom_code = res.financial.custom_code;
            app.weight = res.weight;
            app.discount = res.discount;
            app.width = res.width;
            app.height = res.height;
            app.length = res.length;
            app.price = res.price;
            app.units = res.units;
            app.kind = res.kind;
            app.pricing = res.pricing;
            app.costs = res.costs;
            app.orderPoint = res.order_point;
            app.barcode = res.barcode;
            app.initialCheck = res.initialCheck;
            app.markitoId = res.integrator.markitoId;
            app.basalamId = res.integrator.basalamId;
            app.basalamVariantId = res.integrator.basalamVariantId;
            app.webziVariantId = res.integrator.webziVariantId;
            app.webziId = res.integrator.webziId;
            app.sazitoVariantId = res.integrator.sazitoVariantId;
            app.sazitoId = res.integrator.sazitoId;
            app.portalId = res.integrator.portalId;
            app.portalVariantId = res.integrator.portalVariantId;
            /* app.digikalaVariantId = res.integrator.digikalaVariantId */
            /* app.digikalaFixCount = res.integrator.digikalaFixCount */
            app.woocommerceFixCount = res.integrator.woocommerceFixCount;
            app.woocommerceId = res.integrator.woocommerceId;
            app.body = res.shop ? res.shop.body : null;
            app.digikalaPanel = res.digikalaPanel ? res.digikalaPanel : null;
            app.sazitoPanel = res.sazitoPanel ? res.sazitoPanel : null;
            app.portalPanel = res.portalPanel ? res.portalPanel : null;
            app.mixinPanel = res.mixinPanel ? res.mixinPanel : null;
            app.snapshopPanel = res.snapshopPanel ? res.snapshopPanel : null;
            app.displayPriority = res.priority;
            app.woocommerceVariantId = res.integrator.woocommerceVariantId;
            app.inventoryMethod = res.inventory_method;
            app.investors = res.investors;
            app.allocations =
              res.product_allocation && res.product_allocation.length
                ? res.product_allocation.map((item) => ({
                    id: item.id,
                    percent: item.percent != null ? parseFloat(item.percent) : null,
                    from_date: app
                      .$moment(item.from_date)
                      .format(app.$store.state.date_format),
                    to_date: app
                      .$moment(item.to_date)
                      .format(app.$store.state.date_format),
                  }))
                : [{ percent: null, from_date: null, to_date: null }];
            app.sellCosts = res.sell_costs;
            if (app.type === "product" && res.initial) {
              app.count = res.initial.in;
              app.fee = res.initial.price;
              app.entrepot = res.initial.head ? res.initial.head.entrepot : null;
            }
            if (res.group) {
              app.group = res.group;
            }
            if (res.cat1) {
              app.cat1 = res.cat1;
            }
            if (res.cat2) {
              app.cat2 = res.cat2;
            }
            if (res.unit) {
              app.unit = res.unit;
            }
            if (res.tags) {
              app.tag = res.tags;
            }
            app.render = true;
            app.calcPriceWithTax();
            // app.content = res.content
            // app.$refs.refDescription.setData(res.content)
          });
        })
        .catch((err) => {
          app.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
    update() {
      var app = this;
      app.isLoading = true;
      if (
        !app.isVariableProduct &&
        app.digikalaPanel != undefined &&
        app.sazitoPanel != undefined &&
        app.portalPanel != undefined &&
        app.mixinPanel != undefined &&
        app.snapshopPanel != undefined
      ) {
        if (
          app.digikalaPanel.length == 0 &&
          (app.sazitoPanel.length > 0 ||
            app.portalPanel.length > 0 ||
            app.mixinPanel.length > 0 ||
            app.snapshopPanel.length > 0)
        ) {
          app.digikalaPanel = ["empty"];
        }
        if (
          app.sazitoPanel.length == 0 &&
          app.portalPanel.length == 0 &&
          (app.digikalaPanel.length > 0 ||
            app.mixinPanel.length > 0 ||
            app.snapshopPanel.length > 0)
        ) {
          app.sazitoPanel = ["empty"];
          app.portalPanel = ["empty"];
        }
        if (
          app.mixinPanel.length == 0 &&
          (app.digikalaPanel.length > 0 ||
            app.sazitoPanel.length > 0 ||
            app.portalPanel.length > 0 ||
            app.snapshopPanel.length > 0)
        ) {
          app.mixinPanel = ["empty"];
        }
        if (
          app.snapshopPanel.length == 0 &&
          (app.digikalaPanel.length > 0 ||
            app.sazitoPanel.length > 0 ||
            app.portalPanel.length > 0 ||
            app.mixinPanel.length > 0)
        ) {
          app.snapshopPanel = ["empty"];
        }
      }
      app.removeAvatar = !!app.imagePickerVal && !app.imagePicker;
      app.$axios
        .put(
          app.$endpoint + "products/" + app.$route.params.id,
          app.buildProductPayload()
        )
        .then((res) => {
          res = res.data;
          if (app.imagePicker) {
            app.$refs.refFilePicker
              ? app.$refs.refFilePicker.create(app.$route.params.id)
              : null;
          }
          if (app.productImages) {
            app.$refs.refProductImages
              ? app.$refs.refProductImages.create(app.$route.params.id)
              : null;
          }
          app.$emit("close", app.$route);
          if (app.type === "product") {
            app.goTo("ProductList");
          } else {
            app.goTo("ServiceList");
          }
        })
        .catch((err) => {
          app.serverErrorHandeler(err);
        })
        .finally(() => {
          app.isLoading = false;
          // app.snakbar = false
          app.$emit("close-create-modal");
        });
    },
    getPanels(panels) {
      this.digikalaPanel = panels;
    },
    getSazitoPanels(panels) {
      this.sazitoPanel = panels;
    },
    getPortalPanels(panels) {
      this.portalPanel = panels;
    },
    getMixinPanels(panels) {
      this.mixinPanel = panels;
    },
    getSnapshopPanels(panels) {
      this.snapshopPanel = panels;
    },
    clearForm() {
      this.fee = null;
      this.count = 0;
      this.id = null;
      this.inventoryMethod = "fifo";
      this.priceMethod = "max";
      this.barcodes = null;
      this.woocommerceId = null;
      this.pricing = null;
      this.woocommerceVariantId = null;
      this.image = null;
      this.costs = null;
      this.tag = null;
      this.displayPriority = null;
      this.orderPoint = null;
      this.valid = null;
      this.message = null;
      this.alertType = null;
      this.name = null;
      this.group = null;
      this.cat1 = null;
      this.cat2 = null;
      // this.unit = null;
      this.currency = null;
      this.status = "active";
      this.entrepot = null;
      this.allocations = [{ percent: null, from_date: null, to_date: null }];
      this.digikalaPanel = [];
      this.sazitoPanel = [];
      this.portalPanel = [];
      this.isKalaBarg = false;
      this.mixinPanel = [];
      this.snapshopPanel = [];
      this.discountPercent = null;
      this.barcode = null;
      this.code = 1;
      this.price = null;
      this.custom_code = null;
      this.content = null;
      //add for simple type
      this.priceWithTax = 0;
      this.taxid = null;
      this.discount = null;
      this.branch = null;
      this.kind = null;
      this.variableVariants = [];
      this.isVariableProduct = false;
      this.wasVariableProduct = false;
      this.has_serial = "deactive";
      this.serialDialog = false;
      this.serialItem = null;
      this.initial_stocks = [];
      this.checkCode();
    },
    //advance — toggle
    triggertoAdvance() {
      this.simple = !this.simple;
      this.$emit("trigger", this.simple);
    },
  },
};
</script>

